/* Successful native RFQ returns only. This changes navigation, never submits a form. */
(() => {
  const url = new URL(window.location.href);
  if (!url.pathname.replace(/\/$/, '').endsWith('/pages/contact')) return;
  if (url.searchParams.get('contact_posted') !== 'true') return;
  if (url.hash !== '#VemiloaRFQForm' || url.searchParams.get('view') === 'rfq') return;
  url.searchParams.set('view', 'rfq');
  window.location.replace(url.href);
})();
